import { Modal, Form, Input, Select, message } from "antd";
import { useCreateExpenseType } from "@/pages/Expenses/ManageExpense/hooks/useExpenseTypes";
import { EXPENSE_TYPE_FIELD_OPTIONS } from "@/constants/expenseType";
import { CreateExpenseTypeFormValues } from "@/pages/Expenses/ManageExpense/api/expenseTypes";

interface CreateModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const CreateModal = ({ isOpen, onClose, onSuccess }: CreateModalProps) => {
  const [form] = Form.useForm();
  const { mutate: createExpenseType, isPending } = useCreateExpenseType();

  const handleSubmit = async (values: CreateExpenseTypeFormValues) => {
    createExpenseType(values, {
      onSuccess: () => {
        message.success("Successfully created expense type");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  // Disable available fields for now
  // useEffect(() => {
  //   if (!availableFields) {
  //     return;
  //   }

  //   setRequiredFieldOptions(
  //     EXPENSE_TYPE_FIELD_OPTIONS.filter((field) =>
  //       availableFields.includes(field.value)
  //     )
  //   );

  //   const filteredRequiredFields = requiredFields?.filter((field: string) =>
  //     availableFields.includes(field)
  //   );
  //   form.setFieldValue("required_fields", filteredRequiredFields);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [availableFields, requiredFields]);

  return (
    <Modal
      title="New Type"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Create"
      destroyOnHidden
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea />
        </Form.Item>
        {/* Disable available fields for now */}
        {/* <Form.Item
          name="available_fields"
          label="Available Fields"
          rules={[{ required: true }]}
        >
          <Select
            mode="multiple"
            placeholder="Select available fields"
            options={EXPENSE_TYPE_FIELD_OPTIONS}
          />
        </Form.Item> */}
        <Form.Item
          name="required_fields"
          label="Required Fields"
          rules={[{ required: true }]}
        >
          <Select
            mode="multiple"
            placeholder="Select required fields"
            options={EXPENSE_TYPE_FIELD_OPTIONS}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateModal;
